import React, { PropsWithChildren, useEffect } from "react";
import { getAppointmentsQueryName } from "../apis/tryst/get-appointments";
import queryClient from "../instances/react-query-client";
import BillingTable from "../organisms/billing-queue/billing-queue-table";
import PaymentsDashboardFilterBar from "../organisms/billing-queue/filter-strip";
import PaymentStatusFilters from "../organisms/billing-queue/payment-filters";
import PaymentsDashboardTopBar from "../organisms/billing-queue/top-bar";
import ReceiptCounterPopup from "../organisms/receipt/receipt-counter-popup";
import { RendererParams } from "../react-app-env";
import useBillingStore from "../stores/billing-store/billing-store";
import ReceiptV2 from "../organisms/receipt-v2";
import { getMyAccessProfileV2 } from "../utils/appointment-utils";
import PaymentDashboardInAccessible from "../payment-dashboard-v2/UI/in-accessible";
import { getAppointmentsQueryNameV3 } from "../payment-dashboard-v2/api/useGetAllAppointmentsV2";
import { track } from "../utils/tracking";

export default function PaymentDashboard(
  props: PropsWithChildren<Partial<RendererParams>>
) {
  const { routeParams } = props;
  const { cId, paymentStatusFilter = "all-receipts" } = routeParams || {};

  const {
    clinicId,
    setClinicId,
    showCounterPopup,
    setShowCounterPopup,
    setPaymentGroupFilter,
    resetStore,
  } = useBillingStore();

  useEffect(() => {
    queryClient.removeQueries(getAppointmentsQueryNameV3()); // P0, do not RM this, else even u'll feel like your doing an FS read but react query will serve u cached data. untill stale!! u can say that ohh just pass stale:0 and keepPreviousData: false or refetchOnReconnect: false!! BUT bcoz how poorly these billing components are written! every re-render example on search, payment toggle, check-box EVERYTIME THE HOOK IS RE-RUNNING AND CALLING FS + TRINITY
    if (!!cId) {
      setClinicId({ clinicId: cId });
    }

    return () => {
      resetStore();
      queryClient.removeQueries(getAppointmentsQueryNameV3());
      queryClient.removeQueries(getAppointmentsQueryName());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cId]);

  React.useEffect(() => {
    setPaymentGroupFilter(paymentStatusFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentStatusFilter]);

  const handleCloseCounterPopup = () => {
    setShowCounterPopup(false);
  };

  const profile = getMyAccessProfileV2({ clinicId });
  const hasTooManyDoctors = profile.doctors.length > 30;

  if (hasTooManyDoctors) {
    track("ERROR", {
      on: "TOO_MANY_DOCTORS_IN_HERE",
    });
    return (
      <>
        <PaymentsDashboardTopBar />
        <PaymentDashboardInAccessible />
      </>
    );
  }

  return (
    <div className="flex flex-col h-full w-full overflow-hidden">
      <ReceiptV2 />
      {showCounterPopup && (
        <ReceiptCounterPopup
          clinicId={clinicId}
          onClosePopup={handleCloseCounterPopup}
        />
      )}
      <PaymentsDashboardTopBar />
      <PaymentStatusFilters />
      <div className="px-16 flex-1 flex flex-col pb-16">
        <div className="flex flex-col flex-1 w-full mt-16 overflow-hidden rounded-4">
          <PaymentsDashboardFilterBar />
          <div className="flex-1 w-full table-fader">
            <BillingTable />
          </div>
        </div>
      </div>
    </div>
  );
}
